<template>
  <div class="faq-wrapper">

    <!-- anchor for scrollTo functionality -->
    <div class="faq-anchor-wrapper">
      <div class="faq-anchor" :ref="faqRef"></div>
    </div>

    <div class="row">
      <div @click="toggleShowAnswer" class="col-12">
        <div class="question-wrapper d-flex justify-content-between">
          <div><p v-html="faq.question"></p></div>
          <div class="dropdown-arrow-wrapper pl-4">
            <img
              class="float-right dropdown-arrow align-middle"
              :class="[showAnswer ? 'expanded' : 'collapsed']"
              src="@/assets/dropdown_arrow.svg"
              alt="Dropdown arrow"
            />
          </div>
        </div>
      </div>

      <div v-if="showAnswer" class="col-md-12">
        <div class="answer-wrapper pt-4">
          <div v-html="faq.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "knowledge-faq-collapsible",
  props: ["faq"],
  created() {
    this.showAnswer = this.isFaqOpenOnLoad;
  },
  mounted() {
    this.isFaqOpenOnLoad ? this.$refs[this.faqRef].scrollIntoView() : ''
  },
  data() {
    return {
      showAnswer: false,
    };
  },
  computed: {
    isFaqOpenOnLoad() {
      return this.$route.params.faqId === this.faq.id;
    },
    faqRef() {
      return `faq-${this.faq.id}`;
    }
  },
  methods: {
    toggleShowAnswer() {
      this.showAnswer = !this.showAnswer;
    },
  },
};
</script>

<style scoped>
.question-wrapper :deep(p) {
  margin-bottom: 0 !important;
}
.question-wrapper {
  font-weight: bold;
}
.question-wrapper:hover {
  cursor: pointer;
}

.dropdown-arrow-wrapper {
  display: flex;
  justify-content: center;
}

.dropdown-arrow {
  height: auto;
  width: 9px;
  min-width: 9px;
}

.dropdown-arrow.collapsed {
  transform: rotate(0deg);
  transition: transform 0.1s ease;
}
.dropdown-arrow.expanded {
  transform: rotate(90deg);
  transition: transform 0.1s ease;
}

.faq-anchor {
  position: absolute;
  transform: translateY(-40vh);
}
</style>
